// Mã nguồn NSNN
export default {
  StartData: 0, // Ngày bắt đầu dữ liệu
  StartYear: 1, // Ngày bắt đầu dữ liệu
};
